import { PROFILE_LIST_ACTIONS } from "Store/actions/profileListActions";

const initialState = {
  profiles: [],
  fetchProfilesLoader: true,

  roleEntitlementsLoader: false,
  selectedRoleEntitlementsData: null,
  updateRoleEntitlementsLoader: false,

  featureEntitlementsData: null,
  featureEntitlementsLoader: false,

  toast: {
    show: false,
    message: "",
    type: "error",
  },
};

const profileListReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_LIST_ACTIONS.SET_PROFILES:
      return {
        ...state,
        profiles: action.payload,
      };

    case PROFILE_LIST_ACTIONS.SET_FETCH_PROFILES_LOADER:
      return {
        ...state,
        fetchProfilesLoader: action.payload,
      };

    case PROFILE_LIST_ACTIONS.SET_ROLE_ENTITLEMENTS_LOADER:
      return {
        ...state,
        roleEntitlementsLoader: action.payload,
      };

    case PROFILE_LIST_ACTIONS.SET_UPDATE_ROLE_ENTITLEMENTS_LOADER:
      return {
        ...state,
        updateRoleEntitlementsLoader: action.payload,
      };

    case PROFILE_LIST_ACTIONS.SET_SELECTED_ROLE_ENTITLEMENTS:
      return {
        ...state,
        selectedRoleEntitlementsData: action.payload,
      };

    case PROFILE_LIST_ACTIONS.SET_FEATURE_ENTITLEMENTS: {
      return {
        ...state,
        featureEntitlementsData: action.payload,
      };
    }

    case PROFILE_LIST_ACTIONS.SHOW_TOAST:
      return {
        ...state,
        toast: {
          show: true,
          message: action.payload?.message ?? "",
          type: action.payload?.type ?? "error",
        },
      };

    case PROFILE_LIST_ACTIONS.HIDE_TOAST:
      return {
        ...state,
        toast: {
          show: false,
          message: "",
          type: "error",
        },
      };

    case PROFILE_LIST_ACTIONS.CLEAR_PROFILES:
      return {
        ...initialState,
      };

    case PROFILE_LIST_ACTIONS.CLEAR_PROFILE_DRAWER:
      return {
        ...state,
        selectedRoleEntitlementsData: null,
        featureEntitlementsData: null,
      };

    default:
      return state;
  }
};

export default profileListReducer;